import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { TPayReport } from '../sections/employee/settlement/TPayReport';
import { Employee } from '../pages';

export default () => (
  <Routes>
    <Route path="*" element={<Navigate to="/employee" />} />

    <Route path="/employee" element={<Employee />}>
      <Route path="getpaid-excel" element={<TPayReport />} />
    </Route>
  </Routes>
);
